export default "__VITE_ASSET__CVmbCrbp__"